import token from '@uipath/apollo-core';
export const MuiOutlinedInput = (palette) => {
    return {
        inputMarginDense: {
            paddingLeft: token.Padding.PadXxxl,
            paddingRight: token.Padding.PadXxxl,
            paddingTop: '7.38px',
            paddingBottom: '8px',
            '&.disabled': {
                paddingLeft: token.Padding.PadXxxl,
                paddingRight: token.Padding.PadXxxl,
                paddingTop: '7.38px',
                paddingBottom: '8px',
            },
        },
        root: {
            '&:hover:not(.Mui-focused)': { '& .MuiOutlinedInput-notchedOutline': { borderColor: palette.semantic.colorForeground } },
            '& .MuiOutlinedInput-notchedOutline': {
                top: 0,
                borderColor: palette.semantic.colorForegroundDeEmp,
                '& legend': { '& span': { display: 'none' } },
            },
        },
        input: {
            paddingLeft: token.Padding.PadXxxl,
            paddingRight: token.Padding.PadXxxl,
            paddingTop: '11.38px',
            paddingBottom: '12px',
            color: palette.semantic.colorForeground,
            fontSize: token.FontFamily.FontMSize,
            lineHeight: token.FontFamily.FontMLineHeight,
            '&::placeholder': {
                opacity: 1,
                color: palette.semantic.colorForegroundLight,
            },
            '&.disabled': {
                paddingTop: '11.38px',
                paddingBottom: '12px',
                paddingLeft: token.Padding.PadXxxl,
                paddingRight: token.Padding.PadXxxl,
            },
        },
        multiline: {
            padding: '4px',
            color: palette.semantic.colorForeground,
            fontSize: token.FontFamily.FontMSize,
            lineHeight: token.FontFamily.FontMLineHeight,
        },
        adornedStart: {
            paddingLeft: token.Padding.PadL,
            color: palette.semantic.colorIconDefault,
        },
        inputAdornedStart: { paddingLeft: token.Padding.PadL },
        adornedEnd: {
            color: palette.semantic.colorIconDefault,
            paddingRight: token.Padding.PadL,
        },
        inputAdornedEnd: { paddingRight: token.Padding.PadL },
    };
};
